import React from 'react';

export default function ReceptionActivityTimeline({ items = [] }) {
  if (!items.length) {
    return <p className="text-sm text-muted-foreground">No activity yet.</p>;
  }

  return (
    <ul className="space-y-3 border-l-2 border-primary/30 pl-4">
      {items.map((a) => (
        <li key={a.id} className="relative">
          <span className="absolute -left-[21px] top-1 w-2.5 h-2.5 rounded-full bg-primary" />
          <p className="text-sm font-medium">{a.action?.replace(/_/g, ' ')}</p>
          {a.details && <p className="text-sm text-muted-foreground">{a.details}</p>}
          {a.remarks && <p className="text-sm text-muted-foreground">{a.remarks}</p>}
          <p className="text-xs text-muted-foreground">{a.created_at}</p>
        </li>
      ))}
    </ul>
  );
}
